import tryOnUnMounted from './use/try-on-unmounted';

export type EventHandler = (...args: any[]) => any;

export type VueEventBus = {
  $on: (eventName: string, callback: EventHandler) => void;
  $off: (eventName: string, callback?: EventHandler) => void;
  $emit: (eventName: string, ...args: any[]) => void;
  $once: (eventName: string, callback: EventHandler) => void;
  $offByIframe: (iframeName: string) => void;
};

/**
 * Listens to VueEventBus event and automatically unregisters when component unmounts
 */
function $on(eventName: string, callback: EventHandler): void {
  if (!eventName) {
    console.warn('eventName is required');
    return;
  }
  window?.VueEventBus?.$on(eventName, callback);
  tryOnUnMounted(() => {
    window?.VueEventBus?.$off(eventName, callback);
  });
}

function $off(eventName: string, callback?: EventHandler): void {
  window?.VueEventBus?.$off(eventName, callback);
}

function $emit(eventName: string, ...args: any[]): void {
  window?.VueEventBus?.$emit(eventName, ...args);
}

function $once(eventName: string, callback: EventHandler): void {
  window?.VueEventBus?.$once(eventName, callback);
  tryOnUnMounted(() => {
    window?.VueEventBus?.$off(eventName, callback);
  });
}

function $offByIframe(iframeName: string): void {
  window?.VueEventBus?.$offByIframe(iframeName);
}

const eventBus: VueEventBus = {
  $on,
  $off,
  $emit,
  $once,
  $offByIframe,
};

export default function getVueEventBus(): VueEventBus {
  return eventBus;
}
